const STAGE_LABELS = {
  'REGISTERED': 'Cadastro Realizado',
  'DOCUMENT_UPLOADED': 'Documento Enviado',
  'DOCUMENT_APPROVED': 'Documento Aprovado',
  'TERM_SIGNED': 'Termo Assinado',
  'PROTOCOL_SENT': 'Protocolo Enviado',
  'ACTION_FILED': 'Acao Ajuizada',
  'NEG_SPC_CLEARED': 'Baixa SPC',
  'NEG_BOA_VISTA_CLEARED': 'Baixa Boa Vista',
  'NEG_CENPROT_CLEARED': 'Baixa Cenprot',
  'NEG_SERASA_CLEARED': 'Baixa Serasa',
};

const ALL_STAGES = [
  'REGISTERED',
  'DOCUMENT_UPLOADED',
  'DOCUMENT_APPROVED',
  'TERM_SIGNED',
  'PROTOCOL_SENT',
  'ACTION_FILED',
];

export default function Timeline({ milestones = [] }) {
  const milestoneTypes = new Set(milestones.map(m => m.type));

  const getStatus = (stage) => {
    if (milestoneTypes.has(stage)) return 'done';
    // Check if it's the next expected stage
    const doneStages = ALL_STAGES.filter(s => milestoneTypes.has(s));
    const lastDoneIndex = Math.max(...doneStages.map(s => ALL_STAGES.indexOf(s)), -1);
    if (ALL_STAGES.indexOf(stage) === lastDoneIndex + 1) return 'active';
    return 'pending';
  };

  const getMilestoneDate = (stage) => {
    const ms = milestones.find(m => m.type === stage);
    if (!ms) return null;
    return new Date(ms.occurredAt).toLocaleDateString('pt-BR', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <div className="space-y-0" data-testid="client-process-timeline">
      {ALL_STAGES.map((stage, index) => {
        const status = getStatus(stage);
        const date = getMilestoneDate(stage);
        return (
          <div key={stage} className="grid grid-cols-[20px_1fr] gap-3" data-testid={`client-process-timeline-item-${stage}`}>
            <div className="flex flex-col items-center">
              <div
                className={`h-3 w-3 rounded-full mt-1 ${
                  status === 'done'
                    ? 'bg-[var(--rn-green)]'
                    : status === 'active'
                    ? 'bg-[var(--rn-green)] shadow-[0_0_0_4px_rgba(0,255,163,0.12)]'
                    : 'bg-white/20'
                }`}
              />
              {index < ALL_STAGES.length - 1 && (
                <div className={`w-0.5 flex-1 min-h-[32px] ${
                  status === 'done' ? 'bg-[var(--rn-green)]/40' : 'bg-white/10'
                }`} />
              )}
            </div>
            <div className="pb-4">
              <p className={`text-sm font-medium ${
                status === 'done' ? 'text-white' : status === 'active' ? 'text-[var(--rn-green)]' : 'text-white/40'
              }`}>
                {STAGE_LABELS[stage] || stage}
              </p>
              {date && <p className="text-xs text-white/40 mt-0.5">{date}</p>}
              {status === 'done' && (
                <span className="badge-success text-[10px] mt-1 inline-block">Concluido</span>
              )}
              {status === 'active' && (
                <span className="badge-warning text-[10px] mt-1 inline-block">Pendente</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
